import { FC } from 'react';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { ClosingCalendarDatePicker } from './closing-calendar-date-picker';
import { ClosingCalendarViewDropdown } from './closing-calendar-dropdown';
import { ClosingCalendarStepsDropdown } from './closing-calendar-steps-dropdown';
import { theme } from '../../../../styles/theme';
import { DateArrows } from './date-arrows';
type ICustomHeader = {
  date: Date;
  view: string;
  views: string[];
  label: string;
  onView: (view: string) => void;
  onNavigate: (action: string, date?: Date) => void;
  setStep: (step: number) => void;
  step: number;
};
export const CustomHeader: FC<ICustomHeader> = ({
  date,
  view,
  views,
  label,
  onView,
  onNavigate,
  setStep,
  step
}) => {
  const handleNavigate = (newDate: Date) => {
    onNavigate(navigate.DATE, newDate);
  };

  const steps = [15, 30, 60];
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <Grid
      container
      spacing={0}
      margin={0}
      padding={isMobile ? '1rem' : '1.5rem 2rem'}
      sx={{
        backgroundColor: theme.palette.info.main,
        color: 'white',
        boxShadow: '0px 3px 10px rgba(0,0,0,0.3)'
      }}
      alignItems="center"
    >
      <Grid
        item
        xs={12}
        sm={3}
        display="flex"
        justifyContent={isMobile ? 'center' : 'flex-start'}
      >
        <Typography variant={isMobile ? 'h6' : 'h5'} fontWeight="bold" textAlign="center">
          {label}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={9}
        display="flex"
        justifyContent={isMobile ? 'center' : 'flex-end'}
        alignItems="center"
        gap="1rem"
        flexDirection={isMobile ? 'column' : 'row'}  // Stack items vertically on mobile
      >
        <DateArrows view={view} date={date ?? new Date()} handleNavigate={handleNavigate}>
          <ClosingCalendarDatePicker date={date ?? new Date()} handleNavigate={handleNavigate} />
        </DateArrows>
        {!isMobile && (
          <>
            <ClosingCalendarStepsDropdown steps={steps} selectedStep={step} setStep={setStep} />
            <ClosingCalendarViewDropdown view={view} views={views} onView={onView} />
          </>
        )}
      </Grid>
    </Grid>
  );
};
